/**
 * @fileoverview GET handler for the "/apps/engagement_reports/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsEngagementReportsTags } from "./constants";
import type { AppsEngagementReportsTagsResult } from "./types";

export const getAppsEngagementReportsTags = reactQueryFetcherAdapter(
  appsEngagementReportsTags,
  (signal: AbortSignal, appGroupId: string): Promise<AppsEngagementReportsTagsResult> => {
    return fetch("/apps/engagement_reports/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
